export default "__VITE_ASSET__Dl8T3$Es__"